/* eslint-disable no-unused-vars */

import React, { useEffect } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import HospitalLocationDetails from "../../../components/HospitalLocationConatainer/HospitalLocationDetails";
import { IPetColorItemResponse } from "../../../services/pet-colors/pet-colors.interface";
import { IRootState } from "../../../state";
import { ASSIGNED_BOOKING_TYPE, MODALS } from "../../../config/params";
import { RESCHEDULE_SOURCE } from "../../../navigation/params";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useCancelAndAddAppointment } from "../../../services/appointment/appointment-update-cancel-service";
import { useModal } from "../../../context/ModalContext";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useSelector } from "react-redux";
import { useBookingAppointmentTypeStore } from "../../../hooks";
import { DoctorVisitIcon } from "../../../components/Icons";
import { BookingRescheduleContainer } from "../../containers";

// import { Typography } from "@mui/material";
const RescheduleAVisitModal = () => {
  const { closeModal, openModal } = useModal();
  const { updateAndCancelAppointment, appointmentone } = useCancelAndAddAppointment();
  const { selectedVisit, setSelectedPets, selectedPets, appointmentForm, appointmentDetails } = useAppointmentStore();
  const { sourcePage } = useSelector((state: IRootState) => state.rescheduleSource);
  const { petList } = usePetStore();
  const { appointmentTypeIndicator } = useBookingAppointmentTypeStore();

  const handleCancel = () => {
    closeModal();
  };

  const handleBackClick = ()=>{
    openModal(MODALS.APPOINTMENT_REVIEW);
  };

  const handleContinueCta = ()=>{
    if ((appointmentDetails?.appointmentCreateType === ASSIGNED_BOOKING_TYPE.NORMAL_BOOKING) &&
    (appointmentTypeIndicator === ASSIGNED_BOOKING_TYPE.DROPOFF_BOOKING)) {
      openModal(MODALS.RESCHEDULE_DROP_OFF_MODAL);
    } else {
      updateAndCancelAppointment();
    }
  };


  useEffect(() => {
    if (appointmentone) {
      if (appointmentone.success === false) {
        closeModal();

        return;
      }
      openModal(MODALS.UPDATED_BOOKING_CONFIRMATION_MODAL, RESCHEDULE_SOURCE.DASHBOARD);
    }
  }, [appointmentone]);

  useEffect(() => {
    if (selectedVisit && selectedVisit.pet && petList) {
      setSelectedPets(petList.filter((pet) => pet.id === selectedVisit.pet.id));
    }
  }, [selectedVisit]);

  return (
    <>
      <div className="grow-0 shrink">
        <div className="flex justify-between w-full px-2 pt-1">
          <div>
            {sourcePage === RESCHEDULE_SOURCE.DASHBOARD ?
              <ArrowBackIcon onClick={handleBackClick} className="text-light-black cursor-pointer" /> :
              <></>}
          </div>
          <span onClick={handleCancel} > <ClearIcon className="cursor-pointer" /></span>
        </div>
        <div className="flex flex-col gap-2 items-center">
          <div className="flex items-center justify-center bg-taupe-4 rounded-full p-2 h-fit">
            <DoctorVisitIcon width={40} height={40} />
          </div>
          <div className="flex flex-col items-center gap-1">
            <div className="font-semibold text-2xl">
            Reschedule a Visit
            </div>
            <HospitalLocationDetails />
          </div>
        </div>

      </div>
      <div className="flex flex-col grow shrink ">
        <div className="bg-taupe-15 p-1.5 tracking-wide text-sm mt-5 my-3 mx-4 shadow-sm flex justify-center">
          <div className="grid grid-cols-[auto,1fr] gap-1">
            <div>Reschedule for:</div>
            <div className="font-semibold">
              {selectedPets.map((pet: IPetColorItemResponse) => pet.name).join(", ")}
              {appointmentForm?.day && (
                <span className="font-semibold">
                  <span className="font-normal"> on </span>
                  {appointmentForm?.day}
                  <span className="uppercase">{appointmentForm?.selectedSlotLabel &&
                  `, ${appointmentForm?.selectedSlotLabel}`}</span>
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="w-full h-full flex flex-col gap-2 items-center
      justify-between min-h-0 overflow-y-auto px-3 scrollbar-thin">
          <BookingRescheduleContainer
            handleStep={handleContinueCta}
            isCtaDisabled={appointmentForm?.selectedSlotLabel ? false : true} />
        </div>
      </div>
    </>
  );
};

export default RescheduleAVisitModal;
